import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() type: string = 'button';
  @Input() mode: 'pill' | '' = '';
  @Input() label!: string;
  @Input() isDisabled: boolean = false;
  @Input() customClass: string = '';
  @Input() selected = false;
  @Input() isLoading = false;

  @Output() action: EventEmitter<Event> = new EventEmitter();

  constructor() {}
}
